(() => {
  function initTermsGate(root = document) {
    const gate = root.querySelector('[data-terms-gate]');
    if (!gate) return;

    const boxes = () => Array.from(gate.querySelectorAll('.js-terms'));
    const errorEl = gate.querySelector('.js-terms-error');

    // ドロワー/モーダル内のcheckoutボタンを広めに拾う（テーマ差異吸収）
    const checkoutTargets = () => Array.from(root.querySelectorAll(
      'button[name="checkout"], button[type="submit"][name="checkout"], a[href^="/checkout"], [data-checkout-button], .cart__checkout button, .cart-drawer__footer button'
    ));

    const allChecked = () => {
      const b = boxes();
      return b.length === 6 && b.every(x => x.checked);
    };

    const setDisabled = (disabled) => {
      checkoutTargets().forEach(el => {
        if (el.tagName === 'BUTTON') {
          el.disabled = disabled;
          el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        } else {
          el.style.pointerEvents = disabled ? 'none' : '';
          el.style.opacity = disabled ? '0.5' : '';
          el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
      });
    };

    const sync = (showError = false) => {
      const ok = allChecked();
      setDisabled(!ok);
      if (errorEl) {
        if (ok) errorEl.style.display = 'none';
        else errorEl.style.display = showError ? 'block' : 'none';
      }
    };

    // 初期同期（未チェックなら無効）
    sync(false);

    gate.addEventListener('change', (e) => {
      if (e.target && e.target.classList.contains('js-terms')) sync(false);
    });

    // 押下時ガード（未同意なら止める）
    root.addEventListener('click', (e) => {
      const t = e.target.closest('button[name="checkout"], a[href^="/checkout"], [data-checkout-button]');
      if (!t) return;
      if (allChecked()) return;

      e.preventDefault();
      e.stopPropagation();
      sync(true);
    }, true);
  }

  // 初回
  document.addEventListener('DOMContentLoaded', () => initTermsGate(document));

  // AJAXカートはDOMが差し替わるので監視して再初期化
  const mo = new MutationObserver(() => initTermsGate(document));
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();